// extracted by mini-css-extract-plugin
module.exports = {"modal":"dialog-module--modal--o1RJg","wrapper":"dialog-module--wrapper--uUkOb","back":"dialog-module--back---EFHx","content":"dialog-module--content--2uNdG"};